import cn from 'classnames';
import React from 'react';

import { SortOption } from '@/types/used-cars/used-cars.types';

import styles from './sort-options.module.scss';

export const SortOptions: React.FC<{
  options: SortOption[];
  setSorting: (option: SortOption) => void;
  sorting: SortOption;
}> = ({ options, setSorting, sorting }) => {
  return (
    <>
      {options.map((option, index) => (
        <div
          onClick={() => setSorting(option)}
          key={index}
          className={cn(styles.sortOption, {
            [styles.sortOptionSelected as string]:
              option.value === sorting.value,
          })}
        >
          {option.label}
        </div>
      ))}
    </>
  );
};
